/*!
 * Stockist: zoom the map to a location when it is selected (list click or pin click).
 * Plain JavaScript, no dependencies. Safe to load on every page: it only activates
 * when the Stockist widget (#stockist-widget) and Google Maps are present.
 *
 * Debug: add ?zoomdebug to the page URL to see console logs and a count of
 * Stockist search requests.
 */
(function () {
  'use strict';

  var CONFIG = {
    targetZoom: 14,        // 13 = town, 14 = neighborhood, 15-16 = street
    animateLevels: 3,      // levels animated at the end (0 = instant jump)
    stepMs: 90,            // ms between animated levels
    waitMaxMs: 30000,      // stop waiting for the widget / Google Maps after 30s
    widgetSelector: '#stockist-widget'
  };

  var DEBUG = /[?&]zoomdebug\b/.test(window.location.search);
  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[stockist-zoom]'].concat([].slice.call(arguments)));
    }
  }

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var lastKey = null;
  var token = 0;

  // Accepts google.maps.LatLng or a {lat, lng} literal (old and new marker types)
  function toLatLng(pos) {
    if (!pos) return null;
    var lat = typeof pos.lat === 'function' ? pos.lat() : pos.lat;
    var lng = typeof pos.lng === 'function' ? pos.lng() : pos.lng;
    if (typeof lat !== 'number' || typeof lng !== 'number' || isNaN(lat) || isNaN(lng)) return null;
    return { lat: lat, lng: lng };
  }

  // Only act on the Stockist map, never on any other Google map on the page
  function isStockistMap(map) {
    try {
      var div = map.getDiv();
      return !!(div && div.closest && div.closest(CONFIG.widgetSelector));
    } catch (e) {
      return false;
    }
  }

  function stepZoom(map, target, t) {
    if (t !== token) return;                       // a newer selection took over
    var z = map.getZoom();
    if (typeof z !== 'number' || z >= target) return;
    map.setZoom(z + 1);
    setTimeout(function () { stepZoom(map, target, t); }, CONFIG.stepMs);
  }

  function focusLocation(map, center) {
    var t = ++token;
    var z = map.getZoom();
    var target = CONFIG.targetZoom;
    if (typeof z !== 'number') return;

    if (z >= target) {                             // already close: smooth pan only
      map.panTo(center);
      log('pan to', center);
      return;
    }
    if (reduceMotion || CONFIG.animateLevels <= 0) {
      map.setOptions({ center: center, zoom: target });
      log('jump to', center, 'zoom', target);
      return;
    }
    // One jump most of the way, then animate the last few levels
    var start = Math.max(z, target - CONFIG.animateLevels);
    map.setOptions({ center: center, zoom: start });
    setTimeout(function () { stepZoom(map, target, t); }, CONFIG.stepMs);
    log('zoom', z, '->', target, 'at', center);
  }

  // Mobile: the map sits above the list, so bring it into view if it is off-screen
  function revealMap(map) {
    try {
      var el = map.getDiv();
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < 0 || r.bottom > vh) {
        el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    } catch (e) { /* ignore */ }
  }

  function install(IW) {
    if (IW.prototype.__stockistZoom) return;
    var originalOpen = IW.prototype.open;

    IW.prototype.open = function (a, b) {
      var result = originalOpen.apply(this, arguments);   // Stockist's normal behavior always runs first
      var iw = this;
      try {
        // Supports open(map, anchor) and open({ map, anchor })
        var opts = (a && typeof a.getZoom !== 'function' && ('anchor' in a || 'map' in a))
          ? a : { map: a, anchor: b };

        setTimeout(function () {
          try {
            var map = opts.map || iw.get('map');
            if (!map || typeof map.getZoom !== 'function' || !isStockistMap(map)) return;

            var anc = opts.anchor;
            var center = toLatLng(anc && (anc.getPosition ? anc.getPosition() : anc.position))
                      || toLatLng(iw.getPosition());
            if (!center) return;

            var key = center.lat.toFixed(5) + ',' + center.lng.toFixed(5);
            if (key === lastKey && map.getZoom() >= CONFIG.targetZoom) return;  // same store again
            lastKey = key;

            focusLocation(map, center);
            revealMap(map);
          } catch (e) { log('error', e); }
        }, 50);
      } catch (e) { log('error', e); }

      return result;
    };

    IW.prototype.__stockistZoom = true;
    log('installed');
  }

  // Debug only: count Stockist search requests (no effect on normal visitors)
  function startDebugCounter() {
    if (!DEBUG || !('PerformanceObserver' in window)) return;
    var searches = 0;
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          if (entry.name.indexOf('/locations/search') !== -1) log('search request #' + (++searches));
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* ignore */ }
  }

  // Wait for the Stockist widget AND Google Maps; do nothing on pages without the widget
  var startedAt = Date.now();
  function waitForReady() {
    var widget = document.querySelector(CONFIG.widgetSelector);
    var IW = window.google && window.google.maps && window.google.maps.InfoWindow;
    if (widget && IW) {
      startDebugCounter();
      return install(IW);
    }
    if (Date.now() - startedAt < CONFIG.waitMaxMs) setTimeout(waitForReady, 200);
    else log('Stockist widget or Google Maps not found, zoom disabled');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForReady);
  } else {
    waitForReady();
  }
})();
